const getNextTime = (offset = 0) => {
  const now = new Date();
  const minutes = now.getMinutes() + offset;
  const roundedMinutes = Math.ceil(minutes / 15) * 15;
  const roundedTime = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    now.getHours(),
    roundedMinutes,
  );

  // Formatting the rounded time as "HH:MM"
  const formattedTime = roundedTime.toLocaleTimeString('en-US', {
    hour12: false,
  });

  return formattedTime.replace(/:00$/, '');
};

export default getNextTime;
